import React from 'react';
import {ReactComponent as AiIcon} from "@assets/icons/ai.svg";
import {classNames} from "@utils/class-names";
import AppButton from "@common/components/app-button";

interface AIButtonProps {
    onClick?: () => void;
    label?: string;
    className?: string;
    disabled?: boolean;
    loading?: boolean;
}

const AIButton: React.FC<AIButtonProps> = (props: AIButtonProps) => {
    const {
        onClick,
        label = 'Ulepsz artykuł z AI',
        disabled = false,
        className = "",
        loading
    } = props;

    return (
        <AppButton
            type="button"
            onClick={onClick}
            loading={loading}
            disabled={disabled}
            className={classNames(`
                group relative
                w-fit
                h-[32px] pl-4 pr-2
                rounded-full
                font-semibold text-white text-base
                bg-gradient-to-r from-[#1B59B6] to-[#CB00C3]
                hover:from-cyan-500 hover:to-purple-600
                transition-all duration-300 ease-in-out
                flex items-center gap-1
                overflow-hidden
            `,
                className,
                disabled && "!from-[#787878] !to-[#ADADAD] text-opacity-70 !cursor-auto"
            )}
        >
            <div className="flex gap-1 items-center">
                <span className="relative z-10 font-semibold text-sm">{label}</span>
                <div className="w-[20px] h-[20px] flex items-center justify-center">
                    <AiIcon/>
                </div>
            </div>
        </AppButton>
    );
};

export default AIButton;
